// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3asL6","index":"styles_index__QIhSC"};